<template>
  <div class="q11" :class="{ fade: fade }">
    <div class="content">
      <AppBar></AppBar>
      <img
        class="q-index"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q11-head"
      />
      <div class="q-title animate__animated animate__fadeInDown">
        <img
          class="title-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q11-title"
          alt=""
        />
      </div>
      <div class="q-box">
        <img
          class="q-image image1 animate__animated animate__slideInLeft"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q11-a"
          alt=""
        />
        <QBtn
          v-for="(item, index1) in data[index].field_unit"
          :key="index1"
          class="q-btn animate__animated"
          :class="[
            'btn-' + index1,
            active != -1 && active != index1 ? 'animate__fadeOut' : '',
            active == -1 ? 'animate__bounceIn' : ''
          ]"
          :style="{
            animationDelay: active == -1 ? 0.5 + index1 * 0.2 + 's' : '0s'
          }"
          :type="checkType"
          :sort="item.key"
          :index="index1"
          :active="active"
          @change="bindChange"
          ><span v-html="item.value"></span
        ></QBtn>
      </div>
    </div>
  </div>
</template>
<script>
import QBtn from './q-btn.vue'
import AppBar from '../app-bar.vue'
export default {
  components: {
    QBtn,
    AppBar
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkType: 0, //选择类型
      fade: false,
      active: -1
    }
  },
  mounted() {
    this.$buryPoint('BG_XRWJ_WT11', {})
  },
  methods: {
    bindChange(index) {
      if (this.disabled) {
        return
      }
      this.disabled = true
      this.active = index
      this.data[this.index].value =
        this.data[this.index].field_unit[this.active].key
      this.data[this.index].data_num =
        this.data[this.index].field_unit[this.active].score
      setTimeout(() => {
        this.fade = true
        setTimeout(() => {
          this.$emit('next', this.active)
        }, 500)
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.fade {
  opacity: 0;
}
.q11 {
  opacity: 1;
  transition: opacity 0.5s ease-in;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  min-height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q11-bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .content {
  }
  .pre-btn {
    position: absolute;
    left: 10px;
    top: 20px;
  }
  .q-index {
    width: 328px;
    object-fit: contain;
    margin: 7px auto 13px;
    height: 61px;
  }
  .q-title {
    width: 100%;
    margin-bottom: 42px;
    .title-image {
      margin: 0 17px 0 auto;
      width: 298px;
      height: 85px;
    }
  }
  .q-box {
    height: 443px;
    position: relative;
    margin-bottom: 69px;
    .q-image {
      object-fit: contain;
    }
    .image1 {
      position: absolute;
      width: 194px;
      height: 304px;
      left: 0px;
      top: 82px;
    }
    .q-btn {
      position: absolute;
    }
    .btn-0 {
      top: 0px;
      left: 43px;
    }
    .btn-1 {
      top: 96px;
      left: 141px;
    }
    .btn-2 {
      top: 191px;
      left: 166px;
    }
    .btn-3 {
      top: 287px;
      left: 136px;
    }
    .btn-4 {
      top: 401px;
      left: 50px;
    }
  }
  .q-next {
    margin: 0 auto 57px;
    text-align: center;
    line-height: 40px;
    width: 274px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 22px;
    border: 2px solid rgba(0, 0, 0, 0.9);
  }
}
.fade {
  opacity: 0;
}
</style>
